import { ResourceEnum } from "src/constants/constants.ts";
import React from "react";
import type { ModuleOptions } from "src/system/module.types.ts";

export const module: ModuleOptions = {
  resource: ResourceEnum.AccountingTemplate,
  bigIcon: <span className={"icon-20-reservation"} />,
  smallIcon: <span className={"icon-15-reservation"} />,
};
